import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconWorkflowOutline } from '@icons/IconWorkflowOutline'
import { Dispatch, SetStateAction } from 'react'

export function GroupingActions({
  isRegrouping,
  onToggleRegrouping,
  onSaveGroups,
  onCancelGroups,
  isSubmittingGroups,
  canRegroup,
}: {
  isRegrouping: boolean
  onToggleRegrouping: () => void
  onSaveGroups: () => void
  onCancelGroups: () => void
  isSubmittingGroups: boolean
  canRegroup: boolean
}) {
  if (!canRegroup) return null

  const regroupButton = (
    <TooltipButton tooltip="Groups items">
      <Button size="icon" variant={isRegrouping ? 'default' : 'ghost'} className="size-8" onClick={onToggleRegrouping}>
        <IconWorkflowOutline className="size-4" />
      </Button>
    </TooltipButton>
  )

  const SaveAndCancelButtons = (
    <>
      <Button size="sm" onClick={onSaveGroups} disabled={isSubmittingGroups}>
        Save Groups
      </Button>
      <Button size="sm" variant="outline" onClick={onCancelGroups}>
        Cancel
      </Button>
    </>
  )

  return isRegrouping ? SaveAndCancelButtons : regroupButton
}
